export const clrs = {
    white: "#ffffff",
    whiter: "#F5F5F5",
    black: "#000000",
    grey: "#6F8695",

    blacker: "#292929",
    whiterBlacker: "#8c8b8b",
    darkerBlue :"#004E64",

    yellow: "#FEB50C",
    red: "#FE4646",

    green: "#49AB6C",

    whiterBlue: "#76a3fd",
    whiterRed: "#fc8888",
    whiterGreen: "#7ad99c",

    purple: "#510AC9",

    orange: "#FF4C15",
    whiterOrange: "#ff764d",

    blackerBlue: "#004c86",
    blue: "#0b65b2",
}